import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip as AntDTooltip } from 'antd'

const Tooltip = ({
  children,
  placement,
  title,
  overlayClassName,
  overlayStyle,
  trigger,
  arrowPointAtCenter,
  className,
  visible,
  childWrapClassName,
  childWrapStyleProps,
  color,
  align,
}) => (
  <AntDTooltip
    placement={placement}
    title={title}
    overlayClassName={overlayClassName}
    trigger={trigger}
    arrowPointAtCenter={arrowPointAtCenter}
    defaultVisible={visible}
    className={`tooltip ${className}`}
    overlayStyle={overlayStyle}
    color={color}
    align={align}
  >
    <span style={childWrapStyleProps} className={childWrapClassName}>
      {children}
    </span>
  </AntDTooltip>
)

Tooltip.defaultProps = {
  arrowPointAtCenter: true,
  trigger: 'hover',
  className: '',
  overlayClassName: '',
  childWrapClassName: '',
  visible: false,
  childWrapStyleProps: {},
}

Tooltip.propTypes = {
  color: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  placement: PropTypes.oneOf([
    'top',
    'left',
    'right',
    'bottom',
    'topLeft',
    'topRight',
    'bottomLeft',
    'bottomRight',
    'leftTop',
    'leftBottom',
    'rightTop',
    'rightBottom',
  ]),
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.func,
  ]),
  overlayClassName: PropTypes.string,
  trigger: PropTypes.oneOfType([
    PropTypes.oneOf(['hover', 'focus', 'click', 'contextMenu']),
    PropTypes.arrayOf(
      PropTypes.oneOf(['hover', 'focus', 'click', 'contextMenu'])
    ),
  ]),
  className: PropTypes.string,
  childWrapClassName: PropTypes.string,
  arrowPointAtCenter: PropTypes.bool,
  visible: PropTypes.bool,
  overlayStyle: PropTypes.object,
  childWrapStyleProps: PropTypes.object,
  align: PropTypes.object,
}

export default Tooltip
